var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { getApiService } from './RestApiService.js';
export const QboFetchMixin = (superClass) => {
    class QboFetchClass extends superClass {
        constructor(...args) {
            super(...args);
            this.apiEndpoint = null;
            this.method = 'GET';
            this.error = false;
            this.jsonData = {};
            this.accept = "application/json";
            this.headerTag = 'script[name="headers"]';
            this.html = null;
            this.fetchOnLoad = true;
            this.headers = null;
            this.payload = null;
        }
        async connectedCallback() {
            super.connectedCallback();
            if (this.fetchOnLoad) {
                this.headers = this.headers ?? this.getHeaders();
                this.payload = this.payload ?? this.getPayload(this.headers);
                await this.fetchData(this.headers, this.payload);
            }
        }
        getHeaders() {
            const headerElement = this.querySelector(this.headerTag);
            let headers = { "Accept": this.accept };
            if (headerElement && headerElement.textContent !== null) {
                try {
                    headers = JSON.parse(headerElement.textContent);
                }
                catch (error) {
                    console.error('Error parsing header JSON:', error);
                }
            }
            return headers;
        }
        getPayload(headers) {
            const payloadTag = this.querySelector('script[name="payload"]');
            let payload = null;
            if (payloadTag && payloadTag.textContent !== null) {
                try {
                    payload = JSON.parse(payloadTag.textContent);
                    if (payload)
                        headers["Content-Type"] = "application/json";
                }
                catch (error) {
                    console.error('Error parsing payload JSON:', error);
                }
            }
            return payload;
        }
        /* @description Fetch data from an api, and set @see {@link html} or @see {@link jsonData} with the result. */
        async fetchData(headers, payload) {
            if (this.apiEndpoint === null)
                return;
            if (payload !== null)
                this.method = 'POST';
            try {
                const api = getApiService(this.apiEndpoint);
                const response = await api.fetch(null, payload);
                //const response = await fetch(this.apiEndpoint, {
                //    method: this.method,
                //    headers: headers,
                //    body: payload ? JSON.stringify(payload) : null
                //});
                switch (this.accept) {
                    case "application/json":
                        this.jsonData = response;
                        this.html = null;
                        break;
                    default:
                        this.html = response;
                        this.jsonData = null;
                        break;
                }
                this.dispatchEvent(new CustomEvent('qbo-updated', { bubbles: true, composed: true }));
            }
            catch (err) {
                this.error = true;
                dispatchEvent(new CustomEvent('qbo-error', { detail: err }));
            }
        }
    }
    __decorate([
        property({ type: URL }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "apiEndpoint", void 0);
    __decorate([
        property({ type: String }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "method", void 0);
    __decorate([
        property({ type: Boolean }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "error", void 0);
    __decorate([
        property({ type: Object }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "jsonData", void 0);
    __decorate([
        property({ type: String }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "accept", void 0);
    __decorate([
        property({ type: String }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "headerTag", void 0);
    __decorate([
        property({ type: String }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "html", void 0);
    __decorate([
        property({ type: Boolean }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "fetchOnLoad", void 0);
    __decorate([
        property({ attribute: false }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "headers", void 0);
    __decorate([
        property({ attribute: false }),
        __metadata("design:type", Object)
    ], QboFetchClass.prototype, "payload", void 0);
    ;
    return QboFetchClass;
};
/**
  * Fetches Json data from an API endpoint.
  *
  * @remarks
  * @param apiEndpoint - The API endpoint to fetch data from.
  * @param method - The HTTP method to use when fetching data.
  * @param error - Indicates whether an error occurred while fetching data.
  */
export const QboFetch = QboFetchMixin(LitElement);
